import React from 'react';
import Modify from './modify';
import Tree from './tree';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { classes } from './styles/modify-tree';
import LocationShape from '../../shapes/location';
import CustomerShape from '../../shapes/customer';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillAlt, faBuilding } from '@fortawesome/pro-light-svg-icons';

class CustomerModifyTreeView extends React.Component {

  render() {
    const {
      t,
      customer,
      location,
      disabled,
      onLocationChange,
      onCustomerChange,
      onCreateCustomer,
      onCreateLocation,
      canCreateLocation
    } = this.props;
    // Tree props
    const {
      onToggleOpen,
      open,
      onSelectLocation,
      onSelectCustomer,
      customers,
      locations
    } = this.props;
    // Modify props
    const {
      onSave,
      onCancel,
      canSave
    } = this.props;
    const isCustomer = !!customer;
    const editing = customer || location;
    const onChange = isCustomer ? onCustomerChange : onLocationChange;
    const onModify = property => {
      return (value) => onChange({
        ...(editing || {}),
        [property]: value
      }, property, value);
    };
    const onModifyAddress = property => {
      return (value) => onChange({
        ...(editing || {}),
        address: {
          ...((editing && editing.address) || {}),
          [property]: value
        }
      }, property, value);
    };
    return (
      <div className={classes.container}>
        <div className={classes.treeContainer}>
          <div className={classes.treeActionsContainer}>
            <Button
              color="default"
              size="sm"
              disabled={disabled}
              onClick={onCreateCustomer}
            >
              <FontAwesomeIcon icon={faMoneyBillAlt} />{t('modifyTree.createCustomerAction')}
            </Button>
            <Button
              color="default"
              size="sm"
              disabled={!canCreateLocation || disabled}
              onClick={onCreateLocation}
            >
              <FontAwesomeIcon icon={faBuilding} />{t('modifyTree.createLocationAction')}
            </Button>
          </div>
          <Tree
            onToggleOpen={onToggleOpen}
            open={open}
            onSelectCustomer={onSelectCustomer}
            onSelectLocation={onSelectLocation}
            customers={customers}
            locations={locations}
            disabled={disabled}
            selected={(editing && editing.uuid) || null}
          />
        </div>
        <div className={classes.modifyContainer}>
          <Modify
            customers={customers}
            isCustomer={!editing || isCustomer}
            disabled={!editing || disabled}
            parentUuid={(editing && editing.parentUuid) || ''}
            name={(editing && editing.name) || ''}
            regulatoryLicense={(editing && editing.regulatoryLicense) || ''}
            line1={(editing && editing.address && editing.address.line1) || ''}
            line2={(editing && editing.address && editing.address.line2) || ''}
            city={(editing && editing.address && editing.address.city) || ''}
            zip={(editing && editing.address && editing.address.zip) || ''}
            state={(editing && editing.address && editing.address.state) || ''}
            country={(editing && editing.address && editing.address.country) || ''}
            onParentUuid={onModify('parentUuid')}
            onName={onModify('name')}
            onRegulatoryLicense={onModify('regulatoryLicense')}
            onLine1={onModifyAddress('line1')}
            onLine2={onModifyAddress('line2')}
            onCity={onModifyAddress('city')}
            onZip={onModifyAddress('zip')}
            onState={onModifyAddress('state')}
            onCountry={onModifyAddress('country')}
            onSave={onSave}
            onCancel={onCancel}
            canSave={canSave}
          />
        </div>
      </div>
    )
  }
}

CustomerModifyTreeView.propTypes = {
  onToggleOpen: PropTypes.func.isRequired,
  open: PropTypes.arrayOf(
    PropTypes.string.isRequired
  ),
  onSelectCustomer: PropTypes.func.isRequired,
  onSelectLocation: PropTypes.func.isRequired,
  onCustomerChange: PropTypes.func.isRequired,
  onLocationChange: PropTypes.func.isRequired,
  customer: CustomerShape,
  location: LocationShape,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  canSave: PropTypes.bool.isRequired,
  customers: PropTypes.arrayOf(
    CustomerShape.isRequired
  ).isRequired,
  locations: PropTypes.arrayOf(
    LocationShape.isRequired
  ).isRequired,
  onCreateCustomer: PropTypes.func.isRequired,
  onCreateLocation: PropTypes.func.isRequired,
  canCreateLocation: PropTypes.bool
};

export default translate(['customer'])(CustomerModifyTreeView);


// WEBPACK FOOTER //
// ./src/views/customer/modify-tree.js